import { PureComponent, type ReactNode, StrictMode } from "react";

export class ProfileDetailsSkeleton extends PureComponent {
  render(): ReactNode {
    return (
      <StrictMode>
        <section className="animate-pulse container mx-auto my-10">
          <div className={"text-2xl font-serif"}>Weitere Infos zur Werkstatt</div>

          <div className="my-10 flex gap-2">
            <div className="w-1/2 bg-black-300 h-64 mb-2 rounded-md" />
            <div className="w-1/2 bg-black-300 h-64 mb-2 rounded-md" />
            <div className="w-1/2 bg-black-300 h-64 mb-2 rounded-md" />
          </div>

          <div>
            <div className="font-bold mt-5 mb-3">Öffnungszeiten</div>
            <div className="w-1/2 bg-black-300 h-6 mb-2 rounded-md" />
            <div className="w-1/2 bg-black-300 h-6 mb-2 rounded-md" />
            <div className="w-1/2 bg-black-300 h-6 mb-2 rounded-md" />
            <div className="w-1/2 bg-black-300 h-6 mb-2 rounded-md" />
            <div className="w-1/2 bg-black-300 h-6 mb-2 rounded-md" />
            <div className="w-1/2 bg-black-300 h-6 mb-2 rounded-md" />
            <div className="w-1/2 bg-black-300 h-6 mb-2 rounded-md" />
          </div>

          <div className={"w-full md:w-1/2 my-10"}>
            <div className="font-bold mt-5 mb-3">Beschreibung</div>
            <div className="w-full bg-black-300 h-6 mb-2 rounded-md" />
            <div className="w-full bg-black-300 h-6 mb-2 rounded-md" />
            <div className="w-full bg-black-300 h-6 mb-2 rounded-md" />
          </div>
        </section>
      </StrictMode>
    );
  }
}
